import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import setConvoQuery from './set-convo-query'

export default async function toggleLikedByFollowing(context: BareActionContext<ConvoState, RootState>)
{
  setConvoQuery(context)

  return
}
